import "./index.css";
import GdnAdTemplate from "../GdnAdTemplate";

interface Leaderboard728AdsProps {
  id: string;
  zoom: number;
}

/** Google Display Network — 728×90 leaderboard, available in every layout. */
const Leaderboard728Ads = ({id, zoom}: Leaderboard728AdsProps) => (
  <GdnAdTemplate
    id={id}
    zoom={zoom}
    variant="stacked"
    fallbackTransformId="Leaderboard970Ads"
  />
);

export default Leaderboard728Ads;
